import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const AutoReplenishmentRequestsPage = lazy(
  () =>
    import(
      "../../../../components/WMS/AutoReplenishment/AutoReplenishmentRequestsPage.tsx"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/auto-replenishment/requests/",
)({
  component: AutoReplenishmentRequestsIndexRoute,
})

function AutoReplenishmentRequestsIndexRoute() {
  return (
    <LazyRoutePage>
      <AutoReplenishmentRequestsPage />
    </LazyRoutePage>
  )
}
